import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'src/services/authentication/authentication.service';
import { CompanySelectResponse } from '../models/company-select-response';
import { AccountType } from '../models/enums/account-types.enum';
import { TraxCustomer } from '../models/trax-customer';

@Component({
  selector: 'ftl-quote-auth-customer-select',
  templateUrl: './auth-customer-select.component.html',
  styleUrls: ['./auth-customer-select.component.scss']
})
export class AuthCustomerSelectComponent implements OnInit {
  @Input() customers: TraxCustomer[] = [];
  public currentlySelectedCompany: number = 0;
  constructor(public activeModal: NgbActiveModal,private authService: AuthenticationService) { }

  ngOnInit() {
    this.currentlySelectedCompany = this.authService.getCompanyId();
  }
  public cancel() {
    this.activeModal.close();
  }

  public selectCustomer(customerId: number) {
    if (!this.isCurrentCustomer(customerId)){
      this.activeModal.close(new CompanySelectResponse(customerId, AccountType.Customer));
    }
  }

  public isCurrentCustomer(customerId: number) {
    return customerId === this.authService.getCompanyId();
  }
}
